import React from 'react';
import { Table, Header } from '@amzn/awsui-components-react';

const CAMERA_FACING_MAP: { [key: string]: string } = {
    front: 'Front Short Range',
    driver: 'Front Long Range',
    left: 'Left Rear Positioned',
    right: 'Right Rear Positioned',
    cargo: 'Rear',
    front_short: 'Front Short Range',
    front_long: 'Front Long Range',
    rear: 'Rear',
};

interface EmeraldInformationTableProps {
    emeraldInformation: any;
    title?: string;
}

const EmeraldInformationTable: React.FC<EmeraldInformationTableProps> = ({
    emeraldInformation,
    title = 'Emerald Components',
}) => {
    if (!emeraldInformation) return null;

    const { aiBox, cameras } = emeraldInformation;
    const tableItems = [];

    // Add AI Box information
    if (aiBox) {
        tableItems.push({
            component: 'AI Box',
            serialNumber: aiBox.serialNumber || 'N/A',
            details: `Firmware Version: ${aiBox.fwVersion || 'N/A'}`,
        });
    }

    // Add camera information
    if (cameras?.items) {
        cameras.items.forEach((camera: any) => {
            tableItems.push({
                component: CAMERA_FACING_MAP[camera.facing] || 'Unknown Camera',
                serialNumber: camera.serialNumber || 'N/A',
                details: '',
            });
        });
    }

    return (
        <div>
            <Table
                columnDefinitions={[
                    {
                        id: 'component',
                        header: 'Component',
                        cell: (item: any) => (
                            <span style={{ fontSize: '12px', lineHeight: '1.0' }}>{item.component}</span>
                        ),
                    },
                    {
                        id: 'serialNumber',
                        header: 'Serial Number',
                        cell: (item: any) => (
                            <span style={{ fontSize: '12px', lineHeight: '1.0' }}>{item.serialNumber}</span>
                        ),
                    },
                    {
                        id: 'details',
                        header: 'Details',
                        cell: (item: any) => (
                            <span style={{ fontSize: '12px', lineHeight: '1.0' }}>{item.details}</span>
                        ),
                    },
                ]}
                items={tableItems}
                header={<Header variant="h3">{title}</Header>}
                empty="No Emerald component information available"
            />
        </div>
    );
};

export default EmeraldInformationTable;
